/** `player.capabilities` is keyed by permission strings from the server (same as PERMISSION_KEYS). */
export function hasPermission(player, permissionKey) {
  if (!player?.capabilities || typeof permissionKey !== "string") return false;
  return Boolean(player.capabilities[permissionKey]);
}

/** True when the dynamic matrix grants any permission used by the Admin panel UI. */
export function canAccessAdminArea(player) {
  if (!player?.capabilities) return false;
  const keys = [
    "admin.dashboard.view",
    "admin.stats.view",
    "admin.warps.manage",
    "admin.uploads.manage",
    "admin.tickets.manage",
    "appeals.manage",
    "admin.realestate.manage",
    "admin.forum.manage",
    "admin.submissions.manage",
    "admin.submissions.delete",
    "admin.ban-cases.manage",
    "admin.users.manage",
    "admin.permissions.read",
    "admin.permissions.manage",
    "admin.audit.view",
    "admin.messaging.reports.view",
    "admin.reports.view",
    "admin.reports.acknowledge",
    "admin.newsletter.send",
    "admin.store.manage",
    "admin.store.stats.view",
    "blog.post",
    "blog.edit_own",
    "blog.edit_others",
    "blog.topics.manage",
  ];
  return keys.some((k) => player.capabilities[k]);
}
